import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ChangeDetectionStrategy,
	inject,
} from "@angular/core"
import {
	AutoCompleteKeyUpObj,
	ConfigDefinitions,
	Task,
} from "@app/definitions/types"
import * as moment from "moment"
import { Modalable } from "@app/Modalable"
import { COMMON_IMPORTS } from "../common-imports"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { DatePickerComponent } from "@app/utils/date-picker/date-picker.component"
import { TimePickerComponent } from "@app/utils/time-picker/time-picker.component"
import { BtnExtComponent, CancelBtnComponent } from "@app/utils/utils.component"
import { GenAutocompleteComponent } from "@app/gen-inputs/gen-autocomplete/gen-autocomplete.component"
import { AutocompleteWithTagsComponent } from "@app/gen-inputs/autocomplete-with-tags/autocomplete-with-tags.component"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { TaskSchedulerComponent } from "@app/task-scheduler/task-scheduler.component"
import { StoreService } from "@app/services/store.service"
import { ValidatorService } from "@app/services/validator.service"
import { ApiService } from "@app/services/api.service"
import { PermsService } from "@app/services/perms.service"

@Component({
	selector: "app-add-task",
	imports: [
		COMMON_IMPORTS,
		LangValPipe,
		GenInputComponent,
		DatePickerComponent,
		TimePickerComponent,
		GenAutocompleteComponent,
		BtnExtComponent,
		AutocompleteWithTagsComponent,
		ModalWrapComponent,
		TaskSchedulerComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./add-task.html",
})
export class AddTask {
	store = inject(StoreService)
	validator = inject(ValidatorService)
	apiService = inject(ApiService)
	permsService = inject(PermsService)

	modalProps: any = null
	task = new Task() //the object that holds the field values (and is saved)
	errors: any = {} //will hold errors for the fields in the form
	isFormSubmittable: boolean = false //can submit (controls disabled in the submit button)
	validationFields: any = {
		//field validations, control displaying field errors and ability to submit the form
		content: { not_empty: null },
	}
	isOpen: boolean = false
	@Input() patientRow: any = null

	isSaving: boolean = false
	@Output() saved = new EventEmitter()
	@Output() onSchedulerClose = new EventEmitter()

	ngOnInit() {
		if (this.patientRow) {
			this.choosePatientOrContact({
				id: this.patientRow.id,
				typeClassName: "patients",
			})
		}
		this.isOpen = this.store.cc()?.show_insert_row == "yes"
	}

	validateEntireForm() {
		//validate all fields and detrmine if can be submitted (or has errors)
		this.errors = {}
		this.isFormSubmittable = this.validator.validateEntireForm(
			this.task,
			this.errors,
			this.validationFields
		)
	}

	async submit() {
		if (!this.isFormSubmittable) {
			return
		} //has errors - exit
		this.isSaving = true
		const res: any = await this.apiService.post("create_task", this.task)
		this.isSaving = false
		if (res.id) {
			this.store.get_task_notifications_total()
			this.saved.emit(res.id)
		}
	}
	choosePatientOrContact(obj: any) {
		const isPatient = obj.typeClassName == "patients"
		this.task.patient_id = isPatient ? obj.id : 0
		this.task.contact_id = isPatient ? 0 : obj.id
		if (obj.id) {
			this.validateEntireForm()
		}
	}

	updateSubUsers(objs: any[]) {
		this.task.sub_users = objs
			.map(({ id, typeClassName }) => {
				const isNewId =
					typeClassName != "sub_users" && !String(id).startsWith("g")
				return isNewId ? `g${id}` : id
			})
			.map(String)
		this.validateEntireForm()
	}
}
